import React, { useCallback } from "react";
import { Link, matchPath, Route, Switch, useLocation } from "react-router-dom";
import * as ROUTES from "../../constants/routes";
import WelcomeTour from "./HelpCenter/WelcomeTour";
import "../../scss/help-center.scss";
import { connect } from "react-redux";
import PackagingRequirements from "./HelpCenter/PackagingRequirements";
import PickupPointInformation from "./HelpCenter/PickupPointInformation";

const HelpCenter = (props) => {
  const { pathname } = useLocation();

  const match = (path) => {
    return matchPath(pathname, { path, exact: true });
  };

  const WelcomeTourWithProps = useCallback(
    () => <WelcomeTour fullName={props.full_name} />,
    [],
  );

  return (
    <div className={"help-center d-flex flex-row"}>
      <div className="menu-container d-none d-lg-flex flex-column">
        <div className="d-flex flex-column mb-0">
          {/* <h4>Help Center</h4> */}
          <Link
            to={ROUTES.WELCOME_TOUR}
            className={`${match(ROUTES.WELCOME_TOUR) || match(ROUTES.HELP_CENTER) ? "active" : ""}`}
          >
            Welcome Tour
          </Link>
          <Link
            to={ROUTES.PACKAGING_REQUIREMENTS}
            className={`${match(ROUTES.PACKAGING_REQUIREMENTS) ? "active" : ""}`}
          >
            Packaging Requirements
          </Link>
          <Link
            to={ROUTES.PICKUP_POINT_INFORMATION}
            className={`${match(ROUTES.PICKUP_POINT_INFORMATION) ? "active" : ""}`}
          >
            Pickup Points
          </Link>
          {/*<Link >*/}
          {/*    Shipping Label*/}
          {/*</Link>*/}
        </div>

        {/*<div className="d-flex flex-column">*/}
        {/*    <h4>Call Center</h4>*/}
        {/*    <Link >Call Center Africa</Link>*/}
        {/*</div>*/}
      </div>
      <div className="help-center-content p-0 ml-auto d-flex">
        <Switch>
          <Route path={ROUTES.WELCOME_TOUR} component={WelcomeTourWithProps} />
          <Route
            path={ROUTES.PACKAGING_REQUIREMENTS}
            component={PackagingRequirements}
          />
          <Route
            path={ROUTES.PICKUP_POINT_INFORMATION}
            component={PickupPointInformation}
          />
          <Route path={ROUTES.HELP_CENTER} component={WelcomeTourWithProps} />
        </Switch>
      </div>
    </div>
  );
};

const mapStateToProps = ({ userDetails }) => ({
  full_name: userDetails.info.full_name,
});

export default connect(mapStateToProps, {})(HelpCenter);
